export let designOnMap = require('assets/media/icons/icon_design_on_map.svg');
export let blankPage = require('assets/media/icons/icon_blank_page.svg');
export let importImage = require('assets/media/icons/icon_import_image.svg');
